import React, {
  useState, useCallback,
} from 'react';
import { useMutation } from '@apollo/client';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { ErrorHandler } from '@playbookux/playbook-web-core';
import FilterableGrid from '../../../core/components/filterable-grid';
import InviteTesterModal from './invite-tester-modal';
import ProjectFilter from './project-filter';
import withDashboardSidebar from '../../components/with-dashboard-sidebar';

import { INVITE_TESTERS } from './graphql';

import {
  Container,
  ContainerButton,
  InviteButton,
} from './styles';

import {
  getPaginatedTesters,
  keysFilters,
} from './utils';

import { columnDefs } from './constants';
import DefaultFilterUsers from '../../../core/components/filter-components/default-filter-users';
import { useQueryString } from '../../../core/hooks/use-query-string';

const ManageTesters = () => {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [filters, setFilters] = useState({});
  const [defaultFilters, setDefaultFilters] = useState({
    guest: false,
    status: 'active',
    lastLoginMonths: 12,
  });

  const query = useQueryString();
  const projectIdParams = query.get('project_id');

  const [inviteTesters] = useMutation(INVITE_TESTERS);

  const handleApiCall = useCallback((params) => getPaginatedTesters({ ...params, projectId: projectIdParams }), []);

  const handleCloseInviteModal = () => {
    setShowInviteModal(false);
  };

  const handleOpenInviteModal = () => {
    setShowInviteModal(true);
  };

  const handleClickinvite = async (projectId, segmentId, subject, message) => {
    try {
      await inviteTesters({
        variables: {
          projectId,
          segmentId,
          userIds: selectedUsers,
          subject,
          message,
        },
      });
      setShowErrorMessage(false);
    } catch (ex) {
      if (ex && ex.graphQLErrors[0].message === 'tester_has_already_been_invited') {
        setShowErrorMessage({
          message: 'Tester has already been invited',
        });
      } else {
        setShowErrorMessage(ex);
      }
    }
    setShowInviteModal(false);
  };

  const handleFilterChange = (filterModel) => {
    setFilters(filterModel);
  };

  return (
    <>
      <InviteTesterModal
        open={showInviteModal}
        onClose={handleCloseInviteModal}
        onClickInvite={handleClickinvite}
        disabledInvite={_.isEmpty(selectedUsers)}
      />

      <Container>
        <DefaultFilterUsers
          setDefaultFilters={setDefaultFilters}
          defaultFilters={defaultFilters}
        />
        {projectIdParams && (
          <ProjectFilter
            projectId={projectIdParams}
            onChange={handleFilterChange}
          />
        )}

        <FilterableGrid
          defaultColumns={columnDefs}
          keyFilters={keysFilters}
          onHandleApiCall={handleApiCall}
          onSetSelection={setSelectedUsers}
          preSetFilters={filters}
          order="created_at DESC"
          defaultFilters={defaultFilters}
        />

        <ContainerButton>
          <InviteButton onClick={handleOpenInviteModal}>
            Invite to Project
          </InviteButton>
          {showErrorMessage && (
            <ErrorHandler
              error={showErrorMessage}
              revealError
              defaultMessage="Error while retrieving testers."
            />
          )}
        </ContainerButton>
      </Container>
    </>
  );
};

ManageTesters.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

export default withDashboardSidebar(ManageTesters);
